import Lenis from "lenis";
import {frame} from "motion";
import Swiper from "swiper";
import {Autoplay, EffectFade, Navigation, Pagination} from "swiper/modules";

import.meta.env.DEV && import("@styles/main.sass");

let smoothScroll;

(async () => {
    smoothScroll = new Lenis({anchors: {offset: -40}});
    const raf = time => smoothScroll.raf(time.timestamp)

    frame.update(raf, true);
})();

(() => {
    const header = document.querySelector('header')
    if (!header) return

    let lastScroll = 0

    const hidingOnScroll = () => {
        const currentScroll = window.scrollY;

        if (currentScroll > 320) {
            header.classList.add('Header--stuck')
            header.classList[currentScroll > lastScroll ? 'add' : 'remove']('Header--up')
        } else {
            header.classList.remove('Header--stuck', 'Header--up')
        }

        lastScroll = currentScroll;
    }

    hidingOnScroll();
    window.addEventListener('scroll', () => hidingOnScroll(), { passive: true });

    const menuOpener = header.querySelector('[data-menu-opener]')

    menuOpener?.addEventListener('click', () => header.classList.toggle('Header--open'))
    document.querySelector('[data-header-cover]')?.addEventListener('click', () => header.classList.remove('Header--open'))
})();

(() => {
    const homeHero = document.querySelector<HTMLElement>('[data-hero-swiper]');
    if (!homeHero) return;

    const heroHeadlines = Array.from(homeHero.querySelectorAll<HTMLElement>('[data-hero-slide-title]'))
        .map(headline => headline.innerText);

    new Swiper(homeHero, {
        slidesPerView: 1,
        modules: [Autoplay, Pagination, EffectFade],
        autoplay: {
            delay: 8000,
            //pauseOnMouseEnter: true
        },
        pagination: {
            el: "[data-hero-navigation]",
            type: "bullets",
            clickable: true,
            bulletClass: "bullet",
            bulletActiveClass: "is-active",
            renderBullet: function (index, className) {
                return `<button class="${className}"><strong>${heroHeadlines[index]}</strong></button>`
            }
        },
        speed: 800,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        on: {
            autoplayTimeLeft(s, time, progress) {
                homeHero.parentElement.style.setProperty("--heroSwiperProgress", (1 - progress).toFixed(6).toString());
            }
        }
    })
})();

(() => {
    const upcomingEvents = document.querySelector<HTMLElement>('[data-events-swiper]');
    if (!upcomingEvents) return;

    new Swiper(upcomingEvents, {
        slidesPerView: 1,
        spaceBetween: 20,
        centerInsufficientSlides: true,
        modules: [Navigation, Pagination],
        pagination: {
            el: "[data-events-pagination]",
            type: "bullets",
            clickable: true
        },
        navigation: {
            prevEl: '[data-events-navigation="prev"]',
            nextEl: '[data-events-navigation="next"]'
        },
        breakpoints: {
            640: {
                slidesPerView: 2
            },
            960: {
                slidesPerView: 3
            }
        }
    })
})();

(() => {
    const aboutGallery = document.querySelector<HTMLElement>('[data-about-gallery]');
    if (!aboutGallery) return;

    new Swiper(aboutGallery, {
        slidesPerView: 1,
        modules: [Autoplay, EffectFade],
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        autoplay: {
            delay: 8000,
        }
    })
})();

(() => {
    const jointGallery = document.querySelector<HTMLElement>('[data-joint-gallery]');
    if (!jointGallery) return;

    new Swiper(jointGallery, {
        slidesPerView: 1,
        modules: [EffectFade, Navigation],
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '[data-gallery-navigation="prev"]',
            nextEl: '[data-gallery-navigation="next"]'
        },
    })
})();
